import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function ArticleList() {
  const featuredArticles = getFeaturedArticles();

  return (
    <section className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-14 gap-4">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 mb-4">
              精选文章
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
              使用指南与软件推荐
            </h2>
          </div>
          <Link
            to="/article/getting-started"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-lg bg-white border border-background-200/70 overflow-hidden hover:shadow-sm transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-primary-500/90 text-white">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-4 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.publishDate}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}